// @flow
import * as React from 'react'
import './styles.scss'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/header.css'

type Props = {
  colorGenerator: (input: number) => string,
  ticks: Array<number>,
  tickFormatter: (input: number) => string,
  title: string
}

export function Scale ({ colorGenerator, ticks, tickFormatter, title }: Props) {
  return (
    <div className='scale'>
      <div className='ui sub header'>{title}</div>
      <div className='ticks'>
        {ticks.map((value, index) => {
          return (
            <ColourChip
              colour={colorGenerator(value)}
              legend={tickFormatter(value)}
              key={`tick-${value}`}
            />
          )
        })}
      </div>
    </div>
  )
}

export function ColourChip ({
  children,
  colour,
  legend,
  single = false
}: {
  children?: React.Node,
  colour?: string,
  legend: string,
  single?: boolean
}) {
  let content = children

  if (colour) {
    content = <div className='chip' style={{ backgroundColor: colour }} />
  }

  return (
    <div className={`${single ? 'single' : ''} tick`}>
      {content}
      <div className='legend'>{legend}</div>
    </div>
  )
}
